
export const decodeSlug = (slug: string) => {
  return slug?.replace(/~~~/g, '/');
}

export const encodeSlug = (slug: string)=> {
  return slug?.replace(/\//g, '~~~');
}

/**
 * Человекочитаемый текст ошибки API. Ответ валидации бэкенда — объект {поле: [сообщения]}
 * (или {errors: {...}}); показываем сообщения, а не JSON.
 */
export const formatApiError = (error: any): string => {
  const body = error?.error ?? error;
  if (body == null) { return 'Неизвестная ошибка'; }
  if (typeof body === 'string') { return body; }
  const errors = body.errors && typeof body.errors === 'object' ? body.errors : body;
  const messages: string[] = [];
  for (const value of Object.values(errors)) {
    if (Array.isArray(value)) { messages.push(...value.map(String)); }
    else if (typeof value === 'string') { messages.push(value); }
  }
  if (messages.length) { return messages.join('\n'); }
  if (typeof body.message === 'string') { return body.message; }
  if (typeof body.title === 'string') { return body.title; }
  return JSON.stringify(body);
}
